import BillingsView from "./BillingsView";

const BillingsContainer = () => {
  return <BillingsView />;
};

export default BillingsContainer;
